import { MsalAuthProvider, LoginType } from 'react-aad-msal';
const { REACT_APP_MFAAUTHORITY,
  REACT_APP_PROD_REDIRECT,
  REACT_APP_PROD_CLIENTID,
  REACT_APP_PP_REDIRECT,
  REACT_APP_DEV_CLIENTID,
  REACT_APP_DEV_REDIRECT,
  REACT_APP_PP_CLIENTID } = process.env;

const protocol = window.location.protocol;

const domain = window.location.hostname;

const port = window.location.port;



const url = `${protocol}//${domain}${port ? ":" + port : ""}`;
const clientId = (url === REACT_APP_PROD_REDIRECT) ? REACT_APP_PROD_CLIENTID : (url === REACT_APP_PP_REDIRECT) ? REACT_APP_PROD_CLIENTID : REACT_APP_PROD_CLIENTID;
const redirectUri = (url === REACT_APP_PROD_REDIRECT) ? REACT_APP_PROD_REDIRECT : (url === REACT_APP_PP_REDIRECT) ? REACT_APP_PROD_REDIRECT : REACT_APP_PROD_REDIRECT;

// ✅ Correction MSAL Config
const config = {
  auth: {
    authority: REACT_APP_MFAAUTHORITY,
    clientId: clientId,
    postLogoutRedirectUri: redirectUri,
    redirectUri: redirectUri,
    validateAuthority: true,
    navigateToLoginRequestUrl: false
  },
  cache: {
    // ⚠️ passe en sessionStorage pour éviter que les vieux tokens restent
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
};

// Authentication Parameters
const authenticationParameters = {
  scopes: ["openid"]
}

// Options
const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: redirectUri
}



export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)